const CONTRACT_ADDRESS = '0x0F2F772B49ea69a62Ba4aF630cD72B1e6D104205'; 
const ACCOUNT_ADDRESS = '0xdCFF746b4EBa3446c2ec3794A0961785c7c93013';
const BLOCK_EXPLORER_URL = "https://goerli.etherscan.io/tx";
const OPENSEA_URL = "https://testnets.opensea.io/assets/goerli";

export { CONTRACT_ADDRESS, ACCOUNT_ADDRESS, BLOCK_EXPLORER_URL, OPENSEA_URL }